import { useState } from 'react';
import { ParamFunctionariesSwitchboard } from '../../../../shared/types/param';
import { LayoutModule } from '../../../layout/modules';
import { FuncionariesSwitchboardFiltes } from './filters';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import ActionButtonGroup from '../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../shared/types/profiles';
import {
    FUNCTIONARIES_SWITCHBOARD,
    FUNCTIONARIES_SWITCHBOARD_NEW,
} from '../../../../routes/paths';
import { FunctionariesSwitchboardList } from './list';

export default function FunctionariesSwitchboard() {
    const [filters, setFilters] = useState<ParamFunctionariesSwitchboard>();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    return (
        <>
            <LayoutModule
                title="Funcionarios Conmutador"
                showTitle
                additionalButtons={
                    <ActionButtonGroup
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: FUNCTIONARIES_SWITCHBOARD_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: FUNCTIONARIES_SWITCHBOARD,
                        }}
                    />
                }
            >
                <FuncionariesSwitchboardFiltes
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <FunctionariesSwitchboardList filters={filters} />
        </>
    );
}
